
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decouvrir-l-application-pleinchamp",
      function () {
        return require("private-next-pages/decouvrir-l-application-pleinchamp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decouvrir-l-application-pleinchamp"])
      });
    }
  